import { writable } from "svelte/store";
import { customFetch } from "../customFetch";
import { resourcesUrl } from "../urls";

export const resources = writable([]);
export const isFetching = writable(false);
export const error = writable(null);

export async function load() {
    isFetching.set(true);
    error.set(null);

    try {
        let response = await customFetch(resourcesUrl());

        let data = await response.json();
        data = data.map(elem => {
            elem.UpdatedAt = new Date(elem.UpdatedAt);
            return elem;
        })

        resources.set(data || []);
    } catch (e) {
        error.set(`Can't get actual resources list from server: ${e.message}`);
    }

    isFetching.set(false);
}
